export default __webpack_public_path__ + "static/media/au_eldr.714a3d7a.jpg";